"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileScoresService = void 0;
var OpenAPI_1 = require("../core/OpenAPI");
var request_1 = require("../core/request");
var ProfileScoresService = /** @class */ (function () {
    function ProfileScoresService() {
    }
    /**
     * Embed Builder Profiles
     * Index multiple builders' profiles
     * @param requestBody
     * @returns any Success
     * @returns EmbedData Successful Response
     * @throws ApiError
     */
    ProfileScoresService.embedBuilderProfiles = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/profile-scores/batch/embed',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Hash Builder Profiles
     * Hash the text of multiple builders' profiles
     * @param uids List of builder ids to find similar builders to
     * @returns EmbedHash Success
     * @throws ApiError
     */
    ProfileScoresService.hashBuilderProfiles = function (uids) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/profile-scores/batch/hash',
            query: {
                'uids': uids,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Index Builder Profiles
     * Index multiple builders' profiles
     * @param requestBody
     * @returns any Success
     * @returns team_graph__logic__profile_scores__builder__BatchIndexResult Successful Response
     * @throws ApiError
     */
    ProfileScoresService.indexBuilderProfiles = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/profile-scores/batch',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Embed Builder Profile
     * Index a builder's profile
     * @param uid The builder id
     * @returns any Success
     * @returns EmbedData Successful Response
     * @throws ApiError
     */
    ProfileScoresService.embedBuilderProfile = function (uid) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/profile-scores/{uid}/embed',
            path: {
                'uid': uid,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Hash Builder Profile
     * Hash a builder's texts
     * @param uid The builder id
     * @returns EmbedHash Success
     * @throws ApiError
     */
    ProfileScoresService.hashBuilderProfile = function (uid) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/profile-scores/{uid}/hash',
            path: {
                'uid': uid,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Index Builder Profile
     * Index a builder's profile
     * @param uid The builder id
     * @returns any Success
     * @returns TeamGraph Successful Response
     * @throws ApiError
     */
    ProfileScoresService.indexBuilderProfile = function (uid) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/profile-scores/{uid}',
            path: {
                'uid': uid,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    return ProfileScoresService;
}());
exports.ProfileScoresService = ProfileScoresService;
//# sourceMappingURL=ProfileScoresService.js.map